import { configureStore } from '@reduxjs/toolkit';
import homeContentReducer from './slices/homeContentSlice';
import commonSliceReducer from './slices/commonSlice';

export const store = configureStore({
  reducer: {
    homeContent: homeContentReducer,
    commonSliceState: commonSliceReducer
  },
})